module.exports = __webpack_public_path__ + "static/media/panzer_division.47b75df6.png";